var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { BUY_PICKUP_REQUEST, buyPickupFailure, buyPickupSuccess, } from "@/redux/actions";
import APILocal from "@/utils/APILocal";
export const onBuyPickUp = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APILocal.post(`cnvt/pickup/buy`, action.payload)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* buyPickWorker(action) {
    try {
        const data = yield call(onBuyPickUp, action);
        yield put(buyPickupSuccess(data));
    }
    catch (error) {
        yield put(buyPickupFailure(error));
    }
}
export function* watchBuyPickupData() {
    yield takeLatest(BUY_PICKUP_REQUEST, buyPickWorker);
}
